const GlobalSVGDefs = () => (
  <svg width="0" height="0" style={{ position: "absolute" }}>
    <defs>
      <linearGradient
        id="paint0_linear_217_66"
        x1="2.35093"
        y1="26.3858"
        x2="29.0354"
        y2="6.02392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8C893" />
        <stop offset="0.25" stopColor="#8E8562" />
        <stop offset="0.56" stopColor="#ACA077" />
        <stop offset="1" stopColor="#D8C893" />
      </linearGradient>
    </defs>
  </svg>
);

export default GlobalSVGDefs;
